import { Nominal } from './nominal';

// ISO 8601 Timestamps, new Date().toOSIString(), reference: https://github.com/adlnet/xAPI-Spec/blob/master/xAPI-Data.md#45-iso-8601-timestamps
export type Timestamp = Nominal<string, 'XAPITimestamp'>;

export const timestampFromDate = (date: Date): Timestamp => <Timestamp>date.toISOString();

export const timestampNow = (): Timestamp => timestampFromDate(new Date());
